module.exports = __webpack_public_path__ + "static/media/EE_4.b72ada05.PNG";